<template>
    <div class="history-item-wrapper
        flex flex-row px-2.5 py-3.5 mt-4 last:mb-4
        border border-solid border-light-blue-1 rounded-10px"
        :class="[selectedTab == 0 ? 'non-expired' : 'expired']"
        @click="clickPurchase()"
        v-if="purchase">
        <div class="history-img w-2/5 mr-4 relative">
            <div class="state-wrapper w-full h-full absolute flex items-center">
                <img v-if="isExpired"
                    class="state-icon w-full h-full mx-auto"
                    :class="{'opacity-100': isExpired}"
                    src="@/assets/icon/misc/ic-expired.svg">
                <img v-else-if="isUsed"
                    class="state-icon w-full h-full mx-auto"
                    :class="{'opacity-100': isUsed}"
                    src="@/assets/icon/misc/ic-used.svg">
            </div>
            <img class="w-full h-full"
                :class="{'opacity-60' : isExpired || isUsed}"
                :src="purchase.fullImageUrl">
        </div>
        <div class="history-detail w-3/5 font-main-regular"
            :class="{'opacity-60' : isExpired || isUsed}">
            <div class="brands text-sm text-primary-50 leading-normal uppercase">{{purchase.name_brand}}</div>
            <div class="details text-base text-blue-1 leading-normal uppercase">{{ purchase.name }}</div>
            <div class="date text-sm text-gray-secondary leading-normal ">{{ lbl.history.date }} {{dateComputed}}</div>
            <!-- <div v-if="purchase.isNotAutoUse == false"> -->
            <div v-if="!isExpired && !isUsed"
                class="btn-viewcode text-base text-blue-1 leading-normal">
                <span v-if="isType8" @click.stop="clickViewSlip()">
                    {{lbl.historyPage.view_code}}
                </span>
                <span v-else>
                    {{lbl.historyPage.view_code}}
                </span>
            </div>
            <!-- </div> -->
            <!-- <div v-else>
                <div v-if="!isExpired && !isUsed"
                    class="btn-viewcode text-base text-blue-1 leading-normal">
                    <span v-if="isType8" @click.stop="clickViewSlip()">
                        {{lbl.historyPage.view_code}}
                    </span>
                    <span v-else>
                        {{lbl.historyPage.view_code}}
                    </span>
                </div>
            </div> -->
        </div>
        <!-- Use to reference -->
        <!-- <div>{{purchase.name}}</div>
        <div>{{FilterDateTimeFormat(purchase.redeemDate)}}</div>
        <div>{{getPointMessage()}}</div>
        <div v-if="isShowPurchaseMsg" v-html="purchaseMessage"></div>
        <div v-if="isShowDelivery">{{deliveryMessage}}</div>
        <div v-if="isShipped">{{purchase.parcelNo}}</div>
        <div v-if="isShowPrivilegeMessage" v-html="privilegeMessage"></div> -->
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import DatetimeHelper from "@/helper/DatetimeHelper"

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin],
    props: {
        purchase: { type: Object, required: true },
        selectedTab: Number
    },
    emits: ["onClickPurchase", "onClickViewSlip"],
    data: function() {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
            isExpired: false,
            isUsed: false,
        };
    },
    created: function() {
        this.initialPurchase();
        this.setFlag();
    },
    computed: {
        isShowPurchaseMsg: function() {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface';
        },
        dateComputed: function () {
            let redeemDate = DatetimeHelper.unixTimestampToDate(this.purchase.redeemDate)
            return DatetimeHelper.dateFullFormat(redeemDate, 'd MMM yy');
        },
        isType8: function(){
            return this.purchase.type == CampaignType.Interface
        }
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lbl.history.get_point : this.lbl.history.use_point;
            var pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            //purchase message.
            switch(this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if (this.purchase.serial == "XXXXXXX") {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isExpired = true;
                    } else {
                        this.isActive = true;
                        this.purchaseMessage = this.lbl.purchase.show_code;
                        this.isExpired = false;
                    }
                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isExpired = true
                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            this.purchaseMessage = this.lbl.purchase.interface_use;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },

        clickPurchase: function() {
            if (this.purchase.isNotAutoUse == false && this.purchase.isUsed) {
                if (this.isExpired) return;
                this.tracking.event('redeem_list', 'click_redeemlist', null, null);
                return this.$emit('onClickPurchase', this.purchase);
            }
            if(this.selectedTab !== 1){
                this.tracking.event('redeem_list', 'click_redeemlist', null, null);
                return this.$emit('onClickPurchase', this.purchase);
            }
        },
        clickViewSlip: function(){
            this.$emit("onClickViewSlip", this.purchase)
        },

        setFlag: function(){
            if (this.selectedTab == 1) {
                this.isUsed = this.purchase.arrangedDate != null;
                this.isExpired =
                    (this.purchase.expireIn != null && this.purchase.expireIn < 0) ||
                    (this.purchase.voucherExpireDate != null &&
                        this.purchase.currentDate != null &&
                        this.purchase.voucherExpireDate < this.purchase.currentDate);
                if (this.isUsed && this.isExpired) {
                    this.isExpired = false;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/text.scss";
.history-item-wrapper{
    box-shadow: 0 4px 4px 0 #e0efff;
    &.non-expired{
        height: auto;
    }
    &.expired{
        height: 118px;
    }
    .state-icon{
        width: 59px;
        height: 59px;
    }
    .history-img{
        width: 120px;
        height: 80px;
        z-index: 0;
    }
    .state-wrapper{
        z-index: 1;
    }
    .btn-viewcode{
        text-decoration: underline;
        text-decoration-color: #17377f;
    }
    .history-detail{
        .brands{
            @extend %ellipsis-2;
        }
        .details{
            @extend %ellipsis-2;
        }
    }
}
</style>
